export default "__VITE_ASSET__9c5e7a3b__"